<template>
    <div>
        <el-radio-group
            v-if="radioStyle === 'button'"
            v-model="selectedValue"
            :disabled="mode !== 'edit' || disabled"
        >
            <el-radio-button
                v-for="choice in choices"
                :key="choice.value"
                :label="choice.value"
                :disabled="choice.disabled"
            >
                {{ $filters.capitalize(choice.label) }}
                <p
                    v-if="choice.sublabel"
                    class="mt-1 mb-0 regular"
                    :class="btnTextColor(choice.value)"
                >
                    {{ $filters.capitalize(choice.sublabel) }}
                </p>
            </el-radio-button>
        </el-radio-group>

        <el-radio-group v-else v-model="selectedValue" :disabled="mode !== 'edit' || disabled">
            <el-radio
                v-for="choice in choices"
                :key="choice.value"
                :label="choice.value"
                :disabled="choice.disabled"
            >
                {{ choice.label }}
            </el-radio>
        </el-radio-group>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
        },
        radioStyle: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String, Boolean],
            required: false,
            default: false,
        },
        choices: {
            type: Array,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selectedValue: '',
        };
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue;
        },
        selectedValue(newValue) {
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
    },
    mounted() {
        this.selectedValue = this.value;
    },

    methods: {
        btnTextColor(value) {
            return this.selectedValue === value ? 'white' : 'grey';
        },
    },
};
</script>
